// @ts-nocheck
import { Grid, Box, useTheme } from '@mui/material';
import React from 'react';
import Particles from 'react-particles';
import { loadSlim } from 'tsparticles-slim';
import { withTransaction } from '@elastic/apm-rum-react';
import NimbusLoginPageAnimation from './NimbusLoginPageAnimation';
import { ReactComponent as NimbusUnoDarkTheme } from '../../../assets/NimbusLoginPage/NIMBUSUnoDarkTheme.svg';
/**
 * @function LoginGraphic
 * @description The login page for the application
 * @params {object} history - the history object used to navigate between pages
 * @returns {React.Component} - React component
 */
const LoginGraphic = () => {
  const theme = useTheme();

  const particlesInit = React.useCallback(async (engine) => {
    // console.log(engine);
    // you can initiate the tsParticles instance (engine) here, adding custom shapes or presets
    // this loads the tsparticles package bundle, it's the easiest method for getting everything ready
    // starting from v2 you can add only the features you need reducing the bundle size
    // await loadFull(engine);
    await loadSlim(engine);
  }, []);
  const particlesLoaded = React.useCallback(async () => {}, []);

  return (
    <Grid
      item
      xs={12}
      sm={12}
      md={6}
      px={8}
      py={5}
      backgroundColor={theme.palette.primary.main}
    >
      <Particles
        id="tsparticles"
        init={particlesInit}
        loaded={particlesLoaded}
        height="100vh"
        width="50vw"
        style={{
          position: 'absolute',
          left: 0,
          top: 0,
          width: '50vw',
        }}
        options={{
          fpsLimit: 120,
          interactivity: {
            events: {
              onDiv: {
                selectors: '#loginFormCards',
                enable: false,
                mode: 'repulse',
                type: 'square',
              },
              onClick: {
                enable: false,
                mode: 'push',
              },
              onHover: {
                enable: false,
                mode: 'repulse',
              },
              resize: true,
            },
            modes: {
              push: {
                quantity: 4,
              },
              repulse: {
                distance: 200,
                duration: 0.4,
              },
            },
          },
          particles: {
            color: {
              value: theme.palette.other.white,
            },
            links: {
              color: theme.palette.other.white,
              distance: 150,
              enable: true,
              opacity: 0.2,
              width: 1,
            },
            move: {
              direction: 'none',
              enable: true,
              outModes: {
                default: 'bounce',
              },
              random: true,
              speed: 1,
              straight: false,
            },
            number: {
              density: {
                enable: true,
                area: 800,
              },
              value: 80,
            },
            opacity: {
              value: 0.1,
            },
            // shape: {
            //   type: 'circle',
            // },
            size: {
              value: { min: 1, max: 5 },
            },
          },
          detectRetina: true,
          fullScreen: {
            enable: false,
            zIndex: 0,
          },
        }}
      />
      <Grid item xs={12} height="100%">
        <Box display="flex" flexDirection="row" height="100%" flexGrow={1}>
          <Box
            display="flex"
            flexDirection="column"
            alignItems="flex-start"
            maxWidth="650px"
            flexGrow={1}
            marginX="auto"
            aria-label="NIMBUS UNO"
          >
            <NimbusUnoDarkTheme height="60px" width="120px" />
            <Box
              width="inherit"
              display="flex"
              flexGrow={1}
              alignItems="center"
              justifyContent="center"
            >
              <NimbusLoginPageAnimation />
            </Box>
          </Box>
        </Box>
      </Grid>
    </Grid>
  );
};

export default withTransaction('LoginGraphic', 'component')(LoginGraphic);
